export default __webpack_public_path__ + "static/media/piper-bed.fa3bb650.jpg";